function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoClient4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "361px",
    height: "139px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.306
    },
    fill: "#1f1f1f",
    d: "M 46.5,39.5 C 44.5,39.5 42.5,39.5 40.5,39.5C 42.7025,35.8861 44.7025,35.8861 46.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeeeee",
    d: "M 109.5,37.5 C 116.719,37.3699 123.719,38.5366 130.5,41C 141.991,48.7985 144.491,58.9652 138,71.5C 133.931,76.2854 128.764,79.1188 122.5,80C 112.714,81.5453 103.381,80.2119 94.5,76C 82.9125,65.3257 82.5792,54.3257 93.5,43C 98.6387,40.2259 103.972,38.3925 109.5,37.5 Z M 110.5,46.5 C 117.979,45.7501 124.145,48.0834 129,53.5C 131.757,65.7544 126.757,71.7544 114,71.5C 100.117,72.0439 95.1174,65.7106 99,52.5C 102.308,49.2645 106.141,47.2645 110.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.164
    },
    fill: "#323232",
    d: "M 206.5,39.5 C 202.629,39.185 198.962,39.5184 195.5,40.5C 194.957,40.44 194.624,40.1067 194.5,39.5C 198.649,38.1905 202.649,38.1905 206.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#eeeeee",
    d: "M 66.5,60.5 C 67.3764,60.6309 68.0431,60.2975 68.5,59.5C 65.9135,58.52 63.2469,58.1866 60.5,58.5C 54.0478,58.9155 47.7145,58.4155 41.5,57C 41,56.5 40.5,56 40,55.5C 39.5017,52.1832 39.335,48.8499 39.5,45.5C 39.5,43.8333 39.5,42.1667 39.5,40.5C 39.5,39.8333 39.8333,39.5 40.5,39.5C 42.5,39.5 44.5,39.5 46.5,39.5C 58.7877,38.3732 71.1211,38.2066 83.5,39C 84.1667,41.6667 84.8333,44.3333 85.5,47C 73.9754,48.1479 62.3088,48.9812 50.5,49.5C 58.8305,50.7217 67.1638,51.8884 75.5,53C 80.8148,57.2861 80.8148,61.6194 75.5,66C 67.509,67.0598 59.509,68.0598 51.5,69C 50.5442,72.3936 50.2108,75.8936 50.5,79.5C 46.8333,79.5 43.1667,79.5 39.5,79.5C 39.334,74.1563 39.5006,68.8229 40,63.5C 40.5,63 41,62.5 41.5,62C 49.7918,60.8162 58.1251,60.3162 66.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeeeee",
    d: "M 158.5,65.5 C 157.515,69.6344 157.182,73.9677 157.5,78.5C 154.5,78.5 151.5,78.5 148.5,78.5C 148.5,65.8333 148.5,53.1667 148.5,40.5C 148.918,39.7784 149.584,39.2784 150.5,39C 160.167,38.3333 169.833,38.3333 179.5,39C 191.416,39.9007 195.916,46.0674 193,57.5C 191.167,60.6667 188.667,63.1667 185.5,65C 189.408,69.4851 193.074,74.1518 196.5,79C 192.167,79.6667 187.833,79.6667 183.5,79C 179.806,73.9728 175.473,69.6395 170.5,66C 166.514,65.5012 162.514,65.3345 158.5,65.5 Z M 158.5,48.5 C 165.508,48.3337 172.508,48.5004 179.5,49C 182.306,50.3051 183.14,52.4718 182,55.5C 174.333,56.1667 166.667,56.8333 159,57.5C 158.502,54.5184 158.335,51.5184 158.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#ededed",
    d: "M 195.5,40.5 C 198.962,39.5184 202.629,39.185 206.5,39.5C 211.892,49.2819 217.059,59.2819 222,69.5C 226.512,58.9748 231.679,48.8081 237.5,39C 241.152,38.5014 244.818,38.3347 248.5,38.5C 242.393,52.048 235.726,65.3814 228.5,78.5C 223.95,79.8001 219.45,79.8001 215,78.5C 208.219,65.9364 201.719,53.2697 195.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6e6e6",
    d: "M 255.5,38.5 C 257.92,38.2924 260.253,38.6258 262.5,39.5C 263.666,52.4872 263.833,65.4872 263,78.5C 259.606,79.4558 256.106,79.7892 252.5,79.5C 252.158,67.1595 251.991,54.8262 252,42.5C 252.69,40.6498 253.856,39.3164 255.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f1f1",
    d: "M 289.5,38.5 C 292.85,38.335 296.183,38.5017 299.5,39C 307.439,52.0462 314.439,65.5462 320.5,79.5C 313.514,81.1715 308.514,78.8381 305.5,72.5C 297.833,71.1667 290.167,71.1667 282.5,72.5C 281.5,74.5 280.5,76.5 279.5,78.5C 275.205,79.6609 270.871,79.8275 266.5,79C 273.049,67.4027 279.216,55.5694 285,43.5C 286.059,41.3408 287.559,39.6741 289.5,38.5 Z M 300.5,62.5 C 296.167,63.8333 291.833,63.8333 287.5,62.5C 289.653,58.1932 291.82,53.8599 294,49.5C 296.18,53.8599 298.347,58.1932 300.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.129
    },
    fill: "#000000",
    d: "M 39.5,40.5 C 39.5,42.1667 39.5,43.8333 39.5,45.5C 34.2996,44.1733 34.2996,42.5067 39.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "#d6d6d6",
    d: "M 148.5,40.5 C 148.5,53.1667 148.5,65.8333 148.5,78.5C 151.5,78.5 154.5,78.5 157.5,78.5C 157.182,73.9677 157.515,69.6344 158.5,65.5C 158.5,70.1667 158.5,74.8333 158.5,79.5C 154.833,79.5 151.167,79.5 147.5,79.5C 147.171,66.3226 147.505,53.3226 148.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.443
    },
    fill: "#676767",
    d: "M 60.5,58.5 C 63.2469,58.1866 65.9135,58.52 68.5,59.5C 68.0431,60.2975 67.3764,60.6309 66.5,60.5C 64.5,59.8333 62.5,59.1667 60.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.443
    },
    fill: "#747474",
    d: "M 287.5,62.5 C 291.833,63.8333 296.167,63.8333 300.5,62.5C 301.043,62.56 301.376,62.8933 301.5,63.5C 296.5,64.8333 291.5,64.8333 286.5,63.5C 286.624,62.8933 286.957,62.56 287.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.812
    },
    fill: "#969696",
    d: "M 181.5,92.5 C 183.948,91.5269 186.615,91.1936 189.5,91.5C 189.851,94.0412 189.518,95.7079 188.5,96.5C 188.5,95.1667 188.5,93.8333 188.5,92.5C 186.167,92.5 183.833,92.5 181.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#f3f3f3",
    d: "M 181.5,92.5 C 183.833,92.5 186.167,92.5 188.5,92.5C 188.5,93.8333 188.5,95.1667 188.5,96.5C 185.848,96.4095 183.515,97.0762 181.5,98.5C 180.596,99.209 180.263,100.209 180.5,101.5C 183.167,101.5 185.833,101.5 188.5,101.5C 188.5,103.167 188.5,104.833 188.5,106.5C 186.167,106.5 183.833,106.5 181.5,106.5C 180.517,110.298 180.183,114.298 180.5,118.5C 178.833,118.5 177.167,118.5 175.5,118.5C 175.334,111.159 175.5,103.826 176,96.5C 176.875,93.7854 178.708,92.4521 181.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.818
    },
    fill: "#b5b5b5",
    d: "M 292.5,93.5 C 292.5,94.8333 292.5,96.1667 292.5,97.5C 293.833,97.5 295.167,97.5 296.5,97.5C 296.5,96.1667 296.5,94.8333 296.5,93.5C 297.451,94.9187 297.784,96.5853 297.5,98.5C 295.5,98.5 293.5,98.5 291.5,98.5C 291.216,96.5853 291.549,94.9187 292.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#fdfdfd",
    d: "M 292.5,93.5 C 293.833,93.5 295.167,93.5 296.5,93.5C 296.5,94.8333 296.5,96.1667 296.5,97.5C 295.167,97.5 293.833,97.5 292.5,97.5C 292.5,96.1667 292.5,94.8333 292.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.318
    },
    fill: "#585858",
    d: "M 181.5,98.5 C 183.508,100.083 185.841,101.083 188.5,101.5C 185.833,101.5 183.167,101.5 180.5,101.5C 180.263,100.209 180.596,99.209 181.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#eaeaea",
    d: "M 204.5,101.5 C 205.858,101.822 207.525,101.822 209.5,101.5C 209.5,107.167 209.5,112.833 209.5,118.5C 207.525,118.178 205.858,118.178 204.5,118.5C 193.997,120.498 189.497,116.164 191,105.5C 194.492,100.725 198.992,99.3913 204.5,101.5 Z M 198.5,105.5 C 204.643,106.026 205.976,108.86 202.5,114C 198.803,115.154 196.803,113.821 196.5,110C 196.759,108.213 197.425,106.713 198.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.509
    },
    fill: "#707070",
    d: "M 204.5,118.5 C 205.858,118.178 207.525,118.178 209.5,118.5C 209.5,112.833 209.5,107.167 209.5,101.5C 207.525,101.822 205.858,101.822 204.5,101.5C 206.265,100.539 208.265,100.205 210.5,100.5C 210.5,106.833 210.5,113.167 210.5,119.5C 208.265,119.795 206.265,119.461 204.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#dedede",
    d: "M 214.5,101.5 C 216.167,101.5 217.833,101.5 219.5,101.5C 219.185,105.371 219.518,109.038 220.5,112.5C 221.659,114.377 223.326,114.877 225.5,114C 226.3,109.92 226.8,105.753 227,101.5C 228.699,100.594 230.533,100.261 232.5,100.5C 232.666,105.179 232.499,109.845 232,114.5C 229.103,119.155 224.937,120.655 219.5,119C 218.069,118.535 216.903,117.701 216,116.5C 214.612,111.628 214.112,106.628 214.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#f6f6f6",
    d: "M 242.5,101.5 C 244.167,101.5 245.833,101.5 247.5,101.5C 247.5,102.833 247.5,104.167 247.5,105.5C 245.901,105.232 244.568,105.566 243.5,106.5C 243.5,107.167 243.167,107.5 242.5,107.5C 241.518,110.962 241.185,114.629 241.5,118.5C 240.167,118.5 238.833,118.5 237.5,118.5C 237.5,114.5 237.5,110.5 237.5,106.5C 237.537,103.298 239.203,101.632 242.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#e1e1e1",
    d: "M 256.5,100.5 C 264.07,99.1643 267.903,102.164 268,109.5C 264.527,110.658 261.027,111.824 257.5,113C 260.014,114.804 262.681,114.97 265.5,113.5C 267.517,114.673 268.184,116.173 267.5,118C 256.197,122.048 250.697,118.214 251,106.5C 252.36,103.977 254.193,101.977 256.5,100.5 Z M 257.5,105.5 C 263.866,105.516 263.866,106.516 257.5,108.5C 256.438,107.575 256.438,106.575 257.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#dfdfdf",
    d: "M 278.5,100.5 C 280.857,100.337 283.19,100.503 285.5,101C 287.994,102.912 287.827,104.746 285,106.5C 277.732,105.097 275.898,107.597 279.5,114C 282.131,114.107 284.631,114.273 287,114.5C 289.149,116.724 288.649,118.224 285.5,119C 275.498,120.662 270.998,116.496 272,106.5C 273.436,103.558 275.603,101.558 278.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3f3",
    d: "M 291.5,101.5 C 293.167,101.5 294.833,101.5 296.5,101.5C 296.5,107.167 296.5,112.833 296.5,118.5C 294.833,118.5 293.167,118.5 291.5,118.5C 291.5,112.833 291.5,107.167 291.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#e6e6e6",
    d: "M 315.5,101.5 C 316.833,101.5 318.167,101.5 319.5,101.5C 319.5,107.167 319.5,112.833 319.5,118.5C 318.167,118.5 316.833,118.5 315.5,118.5C 315.565,118.062 315.399,117.728 315,117.5C 307.045,121.272 302.212,118.772 300.5,110C 302.212,101.228 307.045,98.7281 315,102.5C 315.399,102.272 315.565,101.938 315.5,101.5 Z M 308.5,105.5 C 314.643,106.026 315.976,108.86 312.5,114C 307.504,114.664 305.67,112.498 307,107.5C 307.717,106.956 308.217,106.289 308.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.588
    },
    fill: "#606060",
    d: "M 172.5,106.5 C 172.5,104.833 172.5,103.167 172.5,101.5C 171.167,101.5 169.833,101.5 168.5,101.5C 168.5,103.167 168.5,104.833 168.5,106.5C 167.539,104.735 167.205,102.735 167.5,100.5C 169.5,100.5 171.5,100.5 173.5,100.5C 173.795,102.735 173.461,104.735 172.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efefef",
    d: "M 172.5,106.5 C 171.167,106.5 169.833,106.5 168.5,106.5C 168.5,104.833 168.5,103.167 168.5,101.5C 169.833,101.5 171.167,101.5 172.5,101.5C 172.5,103.167 172.5,104.833 172.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.403
    },
    fill: "#707070",
    d: "M 214.5,101.5 C 216.265,100.539 218.265,100.205 220.5,100.5C 220.5,104.5 220.5,108.5 220.5,112.5C 219.518,109.038 219.185,105.371 219.5,101.5C 217.833,101.5 216.167,101.5 214.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.706
    },
    fill: "#8f8f8f",
    d: "M 242.5,101.5 C 244.265,100.539 246.265,100.205 248.5,100.5C 248.5,102.5 248.5,104.5 248.5,106.5C 246.833,106.5 245.167,106.5 243.5,106.5C 244.568,105.566 245.901,105.232 247.5,105.5C 247.5,104.167 247.5,102.833 247.5,101.5C 245.833,101.5 244.167,101.5 242.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.486
    },
    fill: "#727272",
    d: "M 291.5,101.5 C 293.265,100.539 295.265,100.205 297.5,100.5C 297.5,106.833 297.5,113.167 297.5,119.5C 295.265,119.795 293.265,119.461 291.5,118.5C 293.167,118.5 294.833,118.5 296.5,118.5C 296.5,112.833 296.5,107.167 296.5,101.5C 294.833,101.5 293.167,101.5 291.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.673
    },
    fill: "#999999",
    d: "M 315.5,101.5 C 316.919,100.549 318.585,100.216 320.5,100.5C 320.5,106.833 320.5,113.167 320.5,119.5C 318.585,119.784 316.919,119.451 315.5,118.5C 316.833,118.5 318.167,118.5 319.5,118.5C 319.5,112.833 319.5,107.167 319.5,101.5C 318.167,101.5 316.833,101.5 315.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.218
    },
    fill: "#474747",
    d: "M 181.5,106.5 C 181.5,110.833 181.5,115.167 181.5,119.5C 179.265,119.795 177.265,119.461 175.5,118.5C 177.167,118.5 178.833,118.5 180.5,118.5C 180.183,114.298 180.517,110.298 181.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.576
    },
    fill: "#919191",
    d: "M 237.5,106.5 C 237.5,110.5 237.5,114.5 237.5,118.5C 238.833,118.5 240.167,118.5 241.5,118.5C 241.185,114.629 241.518,110.962 242.5,107.5C 242.5,111.5 242.5,115.5 242.5,119.5C 240.5,119.5 238.5,119.5 236.5,119.5C 236.182,114.968 236.515,110.634 237.5,106.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClient4);
export default __webpack_public_path__ + "static/media/logo-client-4.198290bc3ad1f0677f4f13c48fc08f96.svg";
export { ForwardRef as ReactComponent };